import React, { useRef } from "react";
import { TableBody } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useGetScheduleOrders, usePutRescheduleWorkOrder } from "../../hooks";

import ScheduleTableRow from "./ScheduleTableRow";
import { StyledGuideLine } from "./styles";
import { handleRescheduleWorkOrder } from "./putHelper";

export const ScheduleTableBody = ({ defaultLocation = 1 }) => {
  const { data, isLoading: isGetLoading } = useGetScheduleOrders({
    defaultLocation,
  });
  const { mutate: putRescheduleWorkOrder, isLoading: isPutLoading } =
    usePutRescheduleWorkOrder();

  const isLoading = isGetLoading || isPutLoading;

  const days = data?.period?.days || [];
  const rows = data?.rows || [];

  const guideRef = useRef();

  const navigate = useNavigate();

  const handleNav = (e, workOrder) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`/works/${workOrder}`);
  };

  const handleReschedule = (payload) =>
    handleRescheduleWorkOrder(rows, days, putRescheduleWorkOrder, payload);

  return (
    <TableBody sx={{ backgroundColor: "transparent", position: "relative" }}>
      <StyledGuideLine id="GanttBox-VerticalGuide" ref={guideRef} />
      {rows.map((wo, idx) => (
        <ScheduleTableRow
          key={wo?.workOrder}
          wo={wo}
          days={days}
          handleNav={handleNav}
          handleReschedule={handleReschedule}
          guideRef={guideRef}
          idx={idx}
          disabled={isLoading}
        />
      ))}
    </TableBody>
  );
};

export default ScheduleTableBody;
